<template lang='pug'>
  .donations
    .box.mt-4
      .text-right
        .search-box.mr-2
            input.form-control(type='text' placeholder='Nime filter'
              v-model='nameFilter' v-on:keyup.enter='refreshTable'
              v-on:keyup.esc='clearFilter')
            b-btn.search(variant='primary' @click='refreshTable')
              font-awesome-icon(icon='search')
            b-btn.clear(variant='primary' @click='clearFilter')
              font-awesome-icon(icon='backspace')

        b-form-select.campaign-select.mr-2(
          v-model='selectedCampaign' :options='campaigns')

        b-btn(variant='primary' @click='removeDonations' :disabled='selectedDonations.length === 0').mr-2
          font-awesome-icon(icon='trash-alt').mr-2
          | Kustuta

        b-btn(variant='primary' @click='markDonationPaid' :disabled='selectedDonations.length === 0')
          font-awesome-icon(icon='piggy-bank').mr-2
          | Märgi makstuks

      //- Table
      b-table.mt-3(
        :items='donationsProvider'
        :fields='fields'
        :per-page='rowsPerPage'
        :current-page='currentPage'
        ref='donationsTable'
        hover
        striped
        small
        responsive
      )
        template(v-slot:cell(change)='data')
          .form-group.form-check.text-center
            input.form-check-input(
              type='checkbox' :id="'checkbox' + data.index"
              v-model='data.item.selected')

        template(v-slot:cell(paid)='data')
          | {{ data.value ? 'Jah' : 'Ei' }}

        template(v-slot:cell(type)='data')
          | {{ data.value === 'recurring' ? 'püsikorraldus' : data.value }}

        template(v-slot:cell(date)='data')
          | {{ formatDate(data.value) }}

        template(v-slot:cell(amount)='data')
          NumberInput(:theValue='data.value' :size=1 :commit='updateDonation(data.item, "amount")')

        template(v-slot:cell(first_name)='data')
          TextInput(:theValue='data.value' :size=5 :commit='updateDonation(data.item, "first_name")')

        template(v-slot:cell(last_name)='data')
          TextInput(:theValue='data.value' :size=5 :commit='updateDonation(data.item, "last_name")')

        template(v-slot:cell(identification_number)='data')
          TextInput(:theValue='data.value' :size=1 :commit='updateDonation(data.item, "identification_number")')

        template(v-slot:cell(email)='data')
          TextInput(:theValue='data.value' :size=1 :commit='updateDonation(data.item, "email")')

        template(v-slot:cell(phone)='data')
          TextInput(:theValue='data.value' :size=1 :commit='updateDonation(data.item, "phone")')

        template(v-slot:cell(utm)='data')
          UtmPopup(
            :rowId='data.item.id'
            :utmTags='data.item'
          )

      //- Pagination
      b-pagination(align='center' :total-rows='totalRows'
        :per-page='rowsPerPage' v-model='currentPage')

      //- Confirm remove modal
      b-modal(ref='removeModal')
        | Oled kindel, et soovid kustutada järgnevate isikute annetused?
        ul.mt-3
          li(v-for='item in selectedDonations')
            | {{ item.first_name }} {{ item.last_name }}

        template(slot='modal-header')
          h4 Kinnita
        template(slot='modal-footer')
          b-btn(variant='primary' @click='removeModalYes')
            font-awesome-icon(icon='check-circle').mr-2
            | Jah, kustuta
          b-btn(variant='secondary' @click='removeModalNo')
            font-awesome-icon(icon='times-circle').mr-2
            | Ära kustuta
      //- Confirm mark paid modal
      b-modal(ref='markPaidModal')
        | Oled kindel, et soovid märkida järgnevate isikute annetused makstuks?
        ul.mt-3
          li(v-for='item in selectedDonations')
            | {{ item.first_name }} {{ item.last_name }}

        template(slot='modal-header')
          h4 Kinnita
        template(slot='modal-footer')
          b-btn(variant='primary' @click='markPaidModalYes')
            font-awesome-icon(icon='check-circle').mr-2
            | Jah, märgi makstuks
          b-btn(variant='secondary' @click='markPaidModalNo')
            font-awesome-icon(icon='times-circle').mr-2
            | Ära märgi makstuks
</template>

<script>
import { authBackend, formatDate } from '../api'
import TextInput from '../components/TextInput'
import NumberInput from '../components/NumberInput'
import UtmPopup from '../components/UtmPopup.vue'

const rowsPerPage = 20

const fields = [
  { key: 'change',
    label: 'Muuda'
  },
  { key: 'first_name',
    label: 'Eesnimi'
  },
  { key: 'last_name',
    label: 'Perekonnanimi'
  },
  { key: 'identification_number',
    label: 'Isikukood'
  },
  { key: 'email',
    label: 'E-post'
  },
  { key: 'phone',
    label: 'Telefon'
  },
  { key: 'amount',
    label: 'Summa'
  },
  { key: 'type',
    label: 'Tüüp'
  },
  {
    key: 'bank',
    label: 'Pank'
  },
  { key: 'paid',
    label: 'Makstud'
  },
  { key: 'campaign',
    label: 'Kampaania'
  },
  { key: 'date',
    label: 'Kuupäev'
  },
  { key: 'utm',
    label: 'UTM'
  }
]

export default {
  name: 'donations',

  components: { TextInput, NumberInput, UtmPopup },

  data() {
    return {
      fields,
      campaigns: [],
      currentPage: 1,
      rowsPerPage,
      totalRows: 0,
      selectedCampaign: 'Kõik',
      nameFilter: '',
      donations: [],
      utmTags: ['source', 'medium', 'campaign', 'term', 'content']
    }
  },

  async created() {
    const campaignNames = (await authBackend().get('/api/donation/campaigns')).data
    campaignNames.unshift('Kõik')

    const campaigns = []
    for (const name of campaignNames) {
      campaigns.push({
        value: name,
        text: name
      })
    }

    this.campaigns = campaigns
  },

  methods: {
    formatDate,

    async fetchDonations() {
      const cleanedNameFilter = this.nameFilter.replace(/\t/g, ' ')
      const donations = (
        await authBackend().get('/api/donation', { params:
          {
            page: this.currentPage - 1,
            campaign: this.selectedCampaign === 'Kõik' ? undefined : this.selectedCampaign,
            nameFilter: cleanedNameFilter.length === 0 ? undefined : cleanedNameFilter
          }
        })
      ).data

      this.totalRows = donations.totalRows

      const allDonations = donations.donations
      for (const donation of allDonations) {
        donation.selected = false
      }

      this.donations = allDonations

      return allDonations
    },

    donationsProvider(ctx, callback) {
      this.fetchDonations().then(callback)
    },

    refreshTable() {
      this.$refs.donationsTable.refresh()
    },

    clearFilter() {
      this.nameFilter = ''
      this.refreshTable()
    },

    async removeModalYes() {
      this.$refs.removeModal.hide()
      for (const selectedDonation of this.selectedDonations) {
        await authBackend().delete('/api/donation/id/' + selectedDonation.id)
      }
      this.refreshTable()
    },

    removeModalNo() {
      this.$refs.removeModal.hide()
    },

    removeDonations() {
      this.$refs.removeModal.show()
    },

    async markPaidModalYes() {
      this.$refs.markPaidModal.hide()
      for (const selectedDonation of this.selectedDonations) {
        await authBackend().patch('/api/donation/id/' + selectedDonation.id,
          { ...selectedDonation, paid: true }
        )
      }
      this.refreshTable()
    },

    markPaidModalNo() {
      this.$refs.markPaidModal.hide()
    },

    markDonationPaid() {
      this.$refs.markPaidModal.show()
    },

    updateDonation(donation, field) {
      return async (value) => {
        await authBackend().patch(`/api/donation/id/${donation.id}`, { ...donation, [field]: value })
        this.refreshTable()
      }
    },

    atLeastOneUTMTag(donation) {
      return this.utmTags.some((tag) => donation['utm_' + tag] !== null)
    }
  },

  watch: {
    selectedCampaign: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshTable()
      }
    }
  },

  computed: {
    selectedDonations: function() {
      const selected = this.donations.filter(item => item.selected)
      return selected
    }
  }
}
</script>

<style lang="scss">
.donations .search-box {
  display: inline-block;
  margin-right: 8px;

  input {
    display: inline-block;
    width: 200px;
    border-radius: 4px 0 0 4px;
    padding-top: 4px;
  }

  .btn {
    height: 38px;
  }

  .search {
    border-radius: 0;
  }

  .clear {
    border-radius: 0 4px 4px 0;
  }
}

.donations .campaign-select {
  display: inline-block;
  width: 250px;
}

.donations td {
  vertical-align: middle;
}

.donations td .form-check-input {
  margin-top: 0;
}

.utm-icon {
  margin-left: 0.5rem;
  color: #666;
}
</style>
